export default "__VITE_ASSET__D9nnfX2n__"